export default __webpack_public_path__ + "static/media/21bb98fbb0f3864a68eb2de6b4095965.be922229.svg";